export const withdrawType = {
  3: 'Bank Card',
  4: 'GCash',
  5: 'PayMaya',
  6: 'Coins.ph',
  7: 'GoPay',
  8: 'OVO',
  9: 'DANA',
  10: 'PayPal',
  11: 'EPay',
  12: 'Mobile Money(dLocal)',
  13: 'Qiwi',
  14: 'USDT (TRC-20)',
  15: 'Pagsmile',
  16: 'IMPS',
  17: 'UPI',
  18: 'Jazz Cash',
  19: 'Easypaisa',
  20: 'PayPal'
}



// WEBPACK FOOTER //
// ./src/utils/enum.js